export const clothing = [
  {
    name: "Ulos Ragidup",
    description: "Kain tenun sakral Batak yang paling dihormati, digunakan dalam berbagai upacara kehidupan.",
    usage: "Digunakan dalam upacara kelahiran, pernikahan, dan pemakaman. Simbol pelindung spiritual.",
    pattern: "Motif geometris rumit dengan warna merah, putih, dan hitam (Bonang Manalu).",
    meaning: "Melambangkan kehidupan (ragidup = pola kehidupan), kekuatan, dan kemurnian.",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Ulos_Ragidup_%28ceremonial_Shoulder_Cloth%29_%28Indonesia%29%2C_19th_century_%28CH_18437533%29.jpg/960px-Ulos_Ragidup_%28ceremonial_Shoulder_Cloth%29_%28Indonesia%29%2C_19th_century_%28CH_18437533%29.jpg",
    references: [
      {
        title: "Ulos – Wikipedia",
        url: "https://en.wikipedia.org/wiki/Ulos"
      },
      {
        title: "Ceremonial Textile (Ulos Ragidup) – Met Museum",
        url: "https://www.metmuseum.org/art/collection/search/315939"
      }
    ],
  },
  {
    name: "Ulos Sibolang",
    description: "Ulos yang digunakan dalam suasana berkabung atau kesedihan mendalam.",
    usage: "Dipakai dalam upacara kematian dan pemakaman sebagai simbol duka.",
    pattern: "Motif klasik dengan benang berwarna gelap dan detail halus menandakan hormat.",
    meaning: "Melambangkan kesedihan, penghormatan, dan ikatan spiritual dengan yang telah pergi.",
    image: "https://www.rugrabbit.com/sites/default/files/imagecache/640/irfanalya/24-2013/dsc01011.jpg",
    references: [
      {
        title: "Jenis-jenis Ulos, termasuk Sibolang – Onetoba",
        url: "https://onetoba.com/14-types-of-ulos-the-pride-of-the-batak-tribe/"
      },
      {
        title: "Ulos sebagai simbol hangat, kasih sayang, dan status sosial – IndoIndians",
        url: "https://www.indoindians.com/ulos-a-batak-symbol-of-warmth-affection-and-social-status/"
      }
    ],
  },
  {
    name: "Baju Kurung Batak",
    description: "Pakaian adat Batak pria, sering dipadukan dengan ulos tradisional.",
    usage: "Dikenakan pada acara formal atau adat, seperti pernikahan atau upacara resmi.",
    pattern: "Desain polos dengan aksen ulos di bagian leher atau bahu.",
    meaning: "Melambangkan kesederhanaan, martabat, dan identitas budaya Batak.",
    image: "https://awsimages.detik.net.id/community/media/visual/2023/02/23/pakaian-adat-batak-toba_43.jpeg", 
    references: [
      {
        title: "Varian Kebaya Batak (Mirip Baju Kurung) – Wikipedia",
        url: "https://en.wikipedia.org/wiki/Kebaya"
      },
      {
        title: "Ulos dan fungsinya dalam busana adat Batak – Wikipedia ‘Ulos’",
        url: "https://en.wikipedia.org/wiki/Ulos"
      }
    ],
  },
];